import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const App = () => {
	const { i18n } = useTranslation();

	useEffect(() => {
		const syncDocumentLanguage = (language: string) => {
			document.documentElement.lang = language;
		};

		syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);

		i18n.on('languageChanged', syncDocumentLanguage);

		return () => {
			i18n.off('languageChanged', syncDocumentLanguage);
		};
	}, [i18n]);

	return null;
};

export default App;
